export enum CouponType {
  ALL = -1,
  Animation,
  Qing,
  RenderingMember,
  Expired,
  Freeze,
  Desktop = 8,
}

export interface IUserInfo {
  isSubAccount?: boolean;
  isPictureUser?: boolean;
  vocherCount?: number;
  vocherExpireDate?: string;
  userName?: string;
  userId?: number;
  uuid?: string;
  currencySymbol: string;
  userBalance: number;
  userCredit: number;
  userCouponCount: number;
  userCouponPrice: number;
  qyCoupon: number;
  qyCouponCount: number;
  memberLevelTranslate: string;
  authStatusTranslate: string;
  isCertified: boolean;
  isDomestic?: boolean;
  userLevel?: number;
  isHideBalance?: boolean;
  userTotalCredit?: number;
  picMemberValidity?: number;
  isFirstRecharge?: number;
  [key: string]: any;
}

export interface IUserInfoProps {
  userInfo: IUserInfo;
  language?: "zh" | "en";
  toRecharge?: (searchParams?: string) => void;
  toUserCenter?: (to?: string) => void;
  logout?: () => void;
  close?: () => void;
  toAuth?: () => void;
  toCoupon?: (key: CouponType, path?: string) => void;
  toPictureVip?: () => void;
  checkNoPermission?: (key: string) => string;
  onTabChange?: (key: string) => void;
}
